// Lazy load function
const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/inventory/inshell/${file}.vue`);

export default [
  // Current Lots
  {
    path: "/almondco-inshell",
    name: "almondco-inshell",
    meta: { requiresAuth: true, applicationFeatureCode: "Inshell" },
    components: {
      content: lazyLoad('almondco-inshell-current-lots'),
    },
  },
  {
    path: "/almondco-inshell/review/:id",
    name: "almondco-inshell-review",
    meta: { requiresAuth: true, applicationFeatureCode: "Inshell" },
    components: {
      content: lazyLoad('almondco-inshell-current-lots'),
    },
  },
  {
    path: "/almondco-inshell/edit/:id",
    name: "almondco-inshell-edit",
    meta: { requiresAuth: true, applicationFeatureCode: "Inshell" },
    components: {
      content: lazyLoad('almondco-inshell-current-lots'),
    },
  },

  // Freight Labels
  {
    path: "/almondco-freight-labels",
    name: "almondco-freight-labels",
    meta: { requiresAuth: true, applicationFeatureCode: "Inshell" },
    components: {
      content: lazyLoad('almondco-freight-label-list'),
    },
  },
  {
    path: "/almondco-freight-labels/review/:id*",
    name: "almondco-freight-label-review",
    meta: { requiresAuth: true, applicationFeatureCode: "Inshell" },
    components: {
      content: lazyLoad('almondco-freight-label-detail'),
    },
  },
  {
    path: "/almondco-freight-labels/edit/:id*",
    name: "almondco-freight-label-edit",
    meta: { requiresAuth: true, applicationFeatureCode: "Inshell" },
    components: {
      content: lazyLoad('almondco-freight-label-detail'),
    },
  },
  {
    path: "/almondco-freight-labels/create",
    name: "almondco-freight-label-create",
    meta: { requiresAuth: true, applicationFeatureCode: "Inshell" },
    components: {
      content: lazyLoad('almondco-freight-label-create'),
    },
  },

  // Allocation
  {
    path: "/almondco-inshell-allocation",
    name: "almondco-inshell-allocation",
    meta: { requiresAuth: true, applicationFeatureCode: "Inshell" },
    components: {
      content: lazyLoad('almondco-inshell-allocation-list'),
    },
  }
];
